// extracted by mini-css-extract-plugin
export var fadeIn = "_ca-1";
export var modalContent = "_ca-3";
export var overlay = "_ca-0";
export var popoverContent = "_ca-2";
export var results = "_ca-5";
export var searchInputWrapper = "_ca-4";